<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { format } from 'svelte-i18n';

	import { real_id } from '../../helpers/interface_helpers';
	import { capFirstChar, convert, indexToAlphabet } from '../../helpers/utilities';

	import { devices } from 'src/stores/lists/devices';

	// import PowerDataByPhase from './PowerDataByPhase.svelte';
	// import PowerDataTotal from './PowerDataTotal.svelte';
	// import PowerDataN from './PowerDataN.svelte';

	import { ParameterCard, Row, Col, Text } from '@Shelly/shelly-design-system';
	import { onMount } from 'svelte';

	$: settingsStore = getDeviceSettings(device.id);
	export let device, status;

	let is_split = false,
		items = [],
		is_valid,
		n_phase,
		total_n,
		units = 'W',
		wh_units = 'Wh',
		aUnit = 'A',
		vUnit = 'V';

	const totalsCalc = (items) => {
		let total_arr = [],
			power = 0,
			// total_returned = 0,
			total = 0;
		items.forEach((el, i) => {
			power += el.power;
			total += el.total;
			total_arr = [
				{ title: $format('em_power'), value: power, units: 'W' },
				// {
				// 	title: $format('em_total_returned'),
				// 	value: total_returned,
				// 	units: 'Wh'
				// },
				{ title: $format('em_overall'), value: total, units: 'Wh' },
			];
		});
		return total_arr;
	};

	let emmeters = $settingsStore.emeters;

	$: is_split = typeof $devices[real_id(device.id) + '_1'] !== 'undefined';

	$: items = is_split ? [status.emeters[device.channel]] : status.emeters;

	// "emeter_n" prop in the status is added with fw v1.12
	$: if (typeof status.emeter_n !== 'undefined') {
		is_valid = status.emeter_n?.is_valid;
		n_phase = status.emeter_n;
		total_n = [
			{ title: $format('current_n'), value: n_phase.current, units: 'A' },
			{ title: $format('ix_sum_n'), value: n_phase.ixsum, units: 'A' },
		];
	}
</script>

{#if items.length > 1}
	<Text styleType="h2" class="mb-s text-capitalize"
		>{$format('title_total', { default: 'total' })}</Text
	>

	<Row class="mb-m">
		{#each totalsCalc(items) as totalItem}
			<Col>
				<ParameterCard
					title={convert(totalItem.value, totalItem.units)}
					description={totalItem.title}
					size="s"
				/>
			</Col>
		{/each}
	</Row>
{/if}

<!-- N channel -->
{#if is_valid}
	<Text styleType="h2" class="mb-s text-capitalize"
		>{capFirstChar($format('label_power_n_phase', { default: 'Neutral' }))}</Text
	>

	<Row class="mb-m">
		{#each total_n as totalItem}
			<Col>
				<ParameterCard
					title={convert(totalItem.value, totalItem.units)}
					description={totalItem.title}
					size="s"
				/>
			</Col>
		{/each}
	</Row>
{/if}

<Row>
	{#each items as item, i}
		<Col xs={items.length == 1 ? 12 : 4}>
			{#if items.length > 1}
				<Text styleType="h2" class="mb-s text-nowrap">
					{emmeters[i].name
						? emmeters[i].name
						: $format(`label_phase_${indexToAlphabet(i).toLowerCase()}`)}
				</Text>
			{/if}
			<ParameterCard
				title={convert(item.power, units)}
				description={$format('em_power', { default: 'power' })}
				size="s"
				class="mb-s"
			/>
			{#if typeof item.total_returned !== 'undefined'}
				<ParameterCard
					title={convert(item.total_returned, wh_units)}
					description={$format('chart_legend_total_returned', {
						default: 'Total Returned',
					})}
					size="s"
					class="mb-s"
				/>
			{/if}
			<ParameterCard
				title={convert(item.total, wh_units)}
				description={$format('em_overall', { default: 'overall' })}
				size="s"
				class="mb-s"
			/>

			<ParameterCard
				title={convert(item.voltage, vUnit)}
				description={$format('em_voltage', { default: 'voltage' })}
				size="s"
				class="mb-s"
			/>

			{#if typeof item.current !== 'undefined'}
				<ParameterCard
					title={convert(item.current, aUnit)}
					description={$format('em_current', { default: 'current' })}
					size="s"
					class="mb-s"
				/>
			{/if}

			{#if typeof item.reactive !== 'undefined'}
				<ParameterCard
					title={item.reactive + ' VAR'}
					description={$format('em_reactive_power', {
						default: 'recursive power',
					})}
					size="s"
					class="mb-s"
				/>
			{/if}

			<ParameterCard
				title={item.power === 0
					? 'N/A'
					: item.pf
						? item.pf
						: (
								item.power /
								Math.sqrt(Math.pow(item.power, 2) + Math.pow(item.reactive, 2))
							).toFixed(2)}
				description={$format('em_power_factor', { default: 'power factor' })}
				size="s"
				class="mb-s"
			/>
		</Col>
	{/each}
</Row>
